import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { DuplicateDashboardForm } from '../../components/duplicate-dashboard-form';
import { useDuplicateDashboardContext } from '../../context/duplicate-dashboard-context';

export interface DuplicateDashboardFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onDuplicate: () => void;
}

export const DuplicateDashboardFormWizardScreen = ({
  error,
  onClose,
  onDuplicate
}: DuplicateDashboardFormWizardScreenProps) => {
  const intl = useIntl();
  const { form } = useDuplicateDashboardContext();

  const saveText = intl.formatMessage({
    id: 'common.save',
    defaultMessage: 'Save'
  });

  return (
    <WizardScreen onCancel={onClose} onCreate={onDuplicate} footerMode={FooterMode.CREATE} createText={saveText}>
      <>
        {error && <WizardFormError mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />
        <DuplicateDashboardForm
          errors={form.errors}
          name={form.name}
          onChangeName={form.onChangeName}
          revalidate={form.revalidate}
        />
      </>
    </WizardScreen>
  );
};
